/**
 * Componente ThemeSwitcher
 * Botón para alternar entre modo claro y oscuro
 */

import React from 'react';
import { useTheme } from '../hooks/useTheme';

const ThemeSwitcher = ({ className = '' }) => {
  const { toggleTheme, isDark } = useTheme();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={`
        relative inline-flex items-center justify-center
        w-9 h-9 rounded-md
        bg-v4-panel-2 hover:bg-v4-panel-2
        border border-v4-line-2 hover:border-v4-faint
        text-v4-dim hover:text-v4-txt
        transition-colors duration-200
        focus:outline-none focus:ring-2 focus:ring-v4-accent/40 focus:ring-offset-0
        ${className}
      `}
      title={isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
      aria-label={isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
    >
      {/* Sol (modo claro) */}
      <svg
        className={`
          w-4 h-4 absolute
          transition-all duration-300
          ${isDark ? 'opacity-0 rotate-90 scale-0' : 'opacity-100 rotate-0 scale-100'}
        `}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.75}
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
        />
      </svg>

      {/* Luna (modo oscuro) */}
      <svg
        className={`
          w-4 h-4 absolute
          transition-all duration-300
          ${isDark ? 'opacity-100 rotate-0 scale-100' : 'opacity-0 -rotate-90 scale-0'}
        `}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.75}
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
        />
      </svg>
    </button>
  );
};

export default ThemeSwitcher;
